// extracted by mini-css-extract-plugin
export default {"root":"Category_root__SXsGW"};